/**
 * The rev rule (design §3): every durable frame carries its thread's rev. Apply the next one,
 * drop what we already have, and treat anything further ahead as a sign we missed something,
 * which a quiet re-snapshot repairs.
 */
export type RevVerdict = "apply" | "drop" | "gap";

export function classifyRev(mine: number, incoming: number): RevVerdict {
  if (incoming === mine + 1) return "apply";
  return incoming <= mine ? "drop" : "gap";
}
